<template>
    <div>
        <form ref="companyInfoUpdate">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Company id</label>
                    <input id="companyId" v-model="company.companyId"
                           type="text" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.companyId.$error }"/>
                </div>
                <div class="form-group">
                    <label>Company name</label>
                    <input id="name" v-model="company.name"
                           type="text" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.name.$error }"/>
                </div>
                <div class="form-group">
                    <label>Company email</label>
                    <input id="email" v-model="company.email"
                           type="email" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.email.$error }"/>
                </div>
                <div class="form-group">
                    <label>Company telephone</label>
                    <input id="telephone" v-model="company.telephone"
                           type="text" class="form-control" maxlength="15"
                           :class="{ 'is-invalid': submitted && $v.company.telephone.$error }"/>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label>User type</label>
                    <multiselect v-model="company.partnerType"
                                 track-by="id"
                                 label="name"
                                 placeholder="Select one"
                                 :options="company.partnerTypes"
                                 :v-bind:value="company.partnerType"
                                 deselect-label="Can't remove this value"
                                 :searchable="true"
                                 :allow-empty="false">
                        <template slot="singleLabel" slot-scope="{ option }"> {{ option.name }} </template>
                    </multiselect>
                </div>
                <div class="form-group">
                    <label>State</label>
                    <multiselect v-model="company.stateValue"
                                 :options="company.states"
                                 :class="{ 'is-invalid': submitted && $v.company.stateValue.$error }"
                                 deselect-label="Can't remove this value"
                                 :searchable="true"
                                 :allow-empty="false">
                        <template slot="singleLabel" slot-scope="{ option }" selected> {{ option }} </template>
                    </multiselect>
                </div>
                <div class="form-group">
                    <label>Contact person</label>
                    <input id="contactPerson" v-model="company.contactPerson" type="text"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.contactPerson.$error }"/>
                </div>
                <div class="form-group">
                    <label>Contact number</label>
                    <input id="contactNumber" v-model="company.contactNumber"
                           type="text" class="form-control"  maxlength="15"
                           :class="{ 'is-invalid': submitted && $v.company.contactNumber.$error }"/>
                </div>
            </div>

            <div class="col-md-12">
                <div class="form-group">
                    <label>Address</label>
                    <textarea id="address" v-model="company.address"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && $v.company.address.$error }"></textarea>
                </div>
            </div>
        </form>
        <div class="col-md-6">
            <div class="form-group">
                <button type="submit" class="btn btn-primary" @click="submitUpdate" >Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import { companiesMethods } from '@state/helpers'

  import {
    required,
    email,
    minLength,
    maxLength,
  } from 'vuelidate/lib/validators'

  export default {
    components: {Multiselect},
    props: {
      company: {
        type: Object,
        default: null,
      },
      id: {
        type: Number,
        default: null,
      },
      companyData: {
        type: Function,
        default: null
      },
    },
    data() {
      return {
        submitted: false,
        errorKeys: {
          companyId: ['Invalid Company Id', 'Enter a valid Company Id'],
          name: ['Invalid name', 'Enter a valid Company name'],
          email: ['Invalid email', 'Enter a valid Company email'],
          telephone: ['Invalid telephone', 'Enter a valid Company telephone'],
          contactPerson: ['Invalid contact person', 'Enter a valid contact person name'],
          contactNumber: ['Invalid contact number', 'Enter a valid contact number'],
          partnerType: ['Invalid partner type', 'Enter a valid partner type'],
          stateValue: ['Invalid state', 'Enter a valid state'],
          address:['Invalid address', 'Enter a valid address']
        },
      }
    },
    validations: {
      company : {
        companyId: { required, minLength: minLength(3), maxLength: maxLength(10) },
        name: { required },
        email: { required, email },
        telephone: { required, minLength: minLength(7), maxLength: maxLength(15) },
        contactPerson: { required },
        contactNumber: { required, minLength: minLength(7), maxLength: maxLength(15) },
        partnerType: { required },
        stateValue: { required },
        address: { required }
      },
    },
    methods: {
      ...companiesMethods,

      submitUpdate: async function (event) {

        try{
          this.submitted = true

          const telephoneRegex = /^\+[1-9]{1}[0-9]{3,14}$/;

          this.$v.$touch()

          if (!this.$v.$invalid) {

            const {
              companyId,
              email,
              telephone,
              name,
              contactPerson,
              contactNumber,
              address
            } = this.company;

            if(!telephoneRegex.test(telephone)) throw Error('Enter country code in telephone')

            if(!telephoneRegex.test(contactNumber)) throw Error('Enter country code in contact number')

            const { success, message } = await this.updateCompany({
              id: this.id,
              companyId,
              role: this.company.partnerType.id,
              email,
              telephone,
              name,
              contactPerson,
              contactNumber,
              state: this.company.stateValue,
              address
            })

            if(!success) throw Error(message)

            this.$refs.companyInfoUpdate.reset()

            this.appToast('Company updated', message, 'success')

            this.companyData()
          }
          else{

            let isError = false
            Object.keys(this.$v.company.$params).forEach(each=>{
              if(this.$v.company[each].$error){
                if(!isError){
                  isError = true
                  this.appToast(this.errorKeys[each][0], this.errorKeys[each][1], 'danger')
                }
              }
            })
          }
        }
        catch (e){

          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
        }
      }
    },
  }
</script>